// src/features/tag/TagApi.ts

import { webApi } from '@/shared/api/WebApi';
import type {
  TagDeleteResponse,
  TagListResponse,
  TagRenameRequest,
  TagRenameResponse,
  TagUsageResponse,
} from '@/lib/types/Tag';

export class TagApi {
  static async getTags(cId: number): Promise<TagListResponse> {
    return webApi.get<TagListResponse>('tags', { cId });
  }

  static async getTagUsage(cId: number): Promise<TagUsageResponse> {
    return webApi.get<TagUsageResponse>('tags/usage', { cId });
  }

  static async renameTag(cId: number, tagId: number, label: string): Promise<TagRenameResponse> {
    const body: TagRenameRequest = { label };
    return webApi.put<TagRenameResponse>('tags', { cId, tagId }, body);
  }

  static async deleteTag(cId: number, tagId: number): Promise<TagDeleteResponse> {
    return webApi.delete<TagDeleteResponse>('tags', { cId, tagId });
  }
}
